import { GameWithUserGamesDto } from '../../../types/dtos.types';

export const getPlayersFromGame = (game: GameWithUserGamesDto) => {
  const players = game.userGames.map((x) => {
    return { name: x.name, id: x.userId, team: x.team, role: x.role };
  });

  return players;
};
